import { supabase } from '../lib/clients/supabase';

/**
 * Fetches all services with their descriptions and addons
 * @returns {Promise<{data: Array, error: Object}>}
 */
export const fetchAllServices = async () => {
  try {
    const { data, error } = await supabase
      .from('services')
      .select(`
        *,
        service_descriptions!service_descriptions_service_id_fkey (
          id,
          name
        ),
        service_addons!service_addons_service_id_fkey (
          id,
          name,
          price
        ),
        services_base_price!services_base_price_services_id_fkey (
          price,
          vehicle_types:vehicle_types_id (
            id,
            title
          )
        )
      `)
      .order('created_at', { ascending: true });

    if (error) throw error;

    return { data, error: null };
  } catch (error) {
    console.error('Error fetching services:', error);
    return {
      data: null,
      error: {
        message: 'Failed to fetch services',
        details: error.message
      }
    };
  }
};

/**
 * Fetches base prices for services by vehicle type
 * @param {string} serviceId - Optional service ID to filter by
 * @returns {Promise<{data: Array, error: Object}>}
 */
export const fetchServiceBasePrices = async (serviceId = null) => {
  try {
    let query = supabase
      .from('services_base_price')
      .select(`
        *,
        vehicle_types:vehicle_types_id (
          id,
          title,
          image_url
        ),
        services:services_id (
          id,
          name,
          note
        )
      `)
      .order('created_at', { ascending: true });

    if (serviceId) {
      query = query.eq('services_id', serviceId);
    }

    const { data, error } = await query;

    if (error) throw error;

    return { data, error: null };
  } catch (error) {
    console.error('Error fetching service base prices:', error);
    return {
      data: null,
      error: {
        message: 'Failed to fetch service base prices',
        details: error.message
      }
    };
  }
};

/**
 * Fetches all addons for a specific service
 * @param {string} serviceId - The service ID
 * @returns {Promise<{data: Array, error: Object}>}
 */
export const fetchServiceAddons = async (serviceId) => {
  if (!serviceId) {
    return {
      data: null,
      error: {
        message: 'Service ID is required'
      }
    };
  }

  try {
    const { data, error } = await supabase
      .from('service_addons')
      .select('*')
      .eq('service_id', serviceId)
      .order('created_at', { ascending: true });

    if (error) throw error;

    return { data, error: null };
  } catch (error) {
    console.error('Error fetching service addons:', error);
    return {
      data: null,
      error: {
        message: 'Failed to fetch service addons',
        details: error.message
      }
    };
  }
};

/**
 * Fetches the default price (exterior detailing) for each vehicle type
 * @returns {Promise<{data: Array, error: Object}>}
 */
export const fetchDefaultVehiclePrices = async () => {
  try {
    const { data, error } = await supabase
      .from('services_base_price')
      .select(`
        *,
        vehicle_types:vehicle_types_id (*)
      `)
      .eq('services_id', 'd1f24c85-fcba-4432-a101-41831afd7836') // Exterior detailing ID
      .order('created_at', { ascending: true });

    if (error) throw error;

    return { data, error: null };
  } catch (error) {
    console.error('Error fetching default vehicle prices:', error);
    return {
      data: null,
      error: {
        message: 'Failed to fetch default vehicle prices',
        details: error.message
      }
    };
  }
}; 